import { createRouter, createWebHistory } from 'vue-router';
import { listRouter } from './autoRouter';
import { getCookies, removeCookies } from '@/utils/cookies';
import { LOGIN_PATH } from './config';
import { userInfo } from '@/apis/login';

export const USER_CENTER = '/personalInfo';
const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL || '/'),
    routes: listRouter,
    scrollBehavior: (to, from, savedPosition) => {
        return { left: 0, top: 0 }; // 强制滚动到顶部
    },
});
const BLACK_LIST:string[] = [];
let isGetUserInfo = false;
router.beforeEach(async (to, from, next) => {
    const { setUserInfo, clearUserInfo, getUserName, setIp, getRole, getPlatform, getOPActive } = useStore('user');
    const accessToken = getCookies('access_token');
    // console.log(accessToken, 'accessToken', getPlatform.value, getOPActive.value,);
    setIp();
    if (to.path !== '/login') {
        if(!accessToken) {
            clearUserInfo();
            return next('/login');
        } else {
            const res = await userInfo();
            setUserInfo(res);
        }
    }
    if((!getOPActive.value) && (to.path !== '/noAuth' && to.path !== '/login')) {
        return next('/noAuth');
    }
    // if((!getOPActive.value || getPlatform.value != 'brain') && (to.path !== '/noAuth' && to.path !== '/login')) {
    //     return next('/noAuth');
    // }
    next();
});

router.onError((err, to, from) => {
    if (err) {
        ElMessage({ message: '数据更新，刷新页面获取最新数据' });
    }
    console.log('error', err, to, from);
});
export default router;
